/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { deleteData } from "../../hooks/delete";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath, clientSideUrl } from "../../utility/Constant";
import HiringPartnersContentPage from "./hiringPartners/HiringPartnersContentPage";

const HomePartners = () => {
  const { homeApi } = apiPath;
  const { clientHome } = clientSideUrl;
  const [homePartnersData, homePartnersLoading] = useFetch(homeApi);
  const [filteredData, setFilteredData] = useState({});

  useEffect(() => {
    setFilteredData(
      homePartnersData?.filter(
        (item) => item.section_type === "hiring-partners"
      )[0]
    );
  }, [homePartnersData]);

  if (homePartnersLoading) {
    return <Loading />;
  }
  const { hiring_tagline, banner_images, section_type, _id } =
    filteredData ?? {};

  const imagesData = [];
  banner_images?.map((item, index) => {
    imagesData.push({
      label: `Banner Image ${index}`,
      type: "file",
      name: "",
      defaultValue: item,
    });
  });

  const data = [
    {
      elementType: "input",
      label: "Hiring Tagline",
      type: "Text",
      name: "hiring_tagline",
      defaultValue: hiring_tagline,
      required: false,
    },
  ];
  const nestedData = [
    {
      elementType: "file",
      label: "Banner Image",
      name: "banner_images",
      multipleData: imagesData,
      multiple: true,
      required: false,
      handleSingleDelete: handleSingleDelete,
    },
  ];

  const useData = data.concat(nestedData);

  // handle single image deletion
  async function handleSingleDelete(id) {
    const swalResponse = await Swal.fire({
      title: "Are you sure you want to delete this?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        return await deleteData(homeApi, _id, { id });
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
    return swalResponse?.value?.acknowledged;
  }

  const update = (data) => {
    /* const oldImages = data.banner_images.filter((item) => item._id);
    const imageAdded = data.banner_images
      .filter((item) => !item._id)
      .filter((item) => item);
    // create new image array
    const newImagesArray = [];
    if (imageAdded.length) {
      imageAdded.map((item) => newImagesArray.push({ url: item }));
    }
    const combinedImages = [...oldImages, ...newImagesArray];
    // change the old image array to new
    data.banner_images = combinedImages; */
    updateData(homeApi, data, _id);
    setTimeout(() => {
      window.location.reload();
    }, 800);
  };

  return (
    <div>
      <div className="mb-2 w-full text-right font-semibold text-sm">
        <Link
          className="text-black hover:text-[#DB0029]"
          to={clientHome}
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit page
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="inline w-4 h-4 ml-1 align-text-top"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
              />
            </svg>
          </span>
        </Link>
      </div>
      <div className="bg-white p-5 shadow-md rounded-md border mt-5">

        {section_type && <GlobalForm data={data} update={update} />}
      </div>

      <HiringPartnersContentPage apiId={_id} />
    </div>
  );
};

export default HomePartners;
